module.exports = __webpack_public_path__ + "static/media/sample_bulk_trucks.09343fc9.csv";